const suppliers = {
  toast: {
    error: {
      badResponse: '[ספקים] תגובת שרת שגויה',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[ספקים] נוצר בהצלחה',
      },
      edit: {},
    },
  },
  createNew: 'הוסף',
  updateRanking: 'עדכן דירוג',
  table: {
    headers: {
      name: 'שם',
      supplierStatus: 'סטטוס',
      rank: 'דירוג',
      tier: 'שכבה / רמה',
      overallScore: 'ציון כולל',
      onTimePerformance: 'ביצועים בזמן',
      noShowRate: 'שיעור אי-הגעה',
      cancellationsRate: 'שיעור ביטולים',
      acceptanceRate: 'שיעור קבלה',
      avgResponseTime: 'זמן תגובה ממוצע',
      vehicles: 'רכבים',
      complaints: 'תלונות',
    },
    actions: {
      delete: 'מחק',
      export: 'ייצא',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission require',
    },
  },

  create: {
    successToast: {
      message: 'הצלחה! ספק נוצר!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן ליצור ספק',
    },
  },

  edit: {
    successToast: {
      message: 'הצלחה! ספק עודכן!',
    },
    errorToast: {
      message: 'אירעה שגיאה. לא ניתן לעדכן ספק',
    },
  },

  deleteModal: {
    header: 'מחק ספקים',
    body: 'אתה עומד למחוק {{num}} ספקים.',
  },

  deleteToast: 'לא ניתן למחוק ספקים',

  forms: {
    header: {
      createSupplier: {
        title: 'הוסף',
      },

      updateSupplier: {
        title: 'עדכן',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      rank: {
        header: '	דירוג ספק',
        fields: {
          rank: 'דרגה {{rank}}',
          score: 'ניקוד: ',
        },
      },
      generalInformation: {
        header: 'מידע כללי',
        fields: {
          name: 'שם',
          unit: 'אתר',
          status: 'סטטוס',
          tier: 'שכבה / רמה',
          tierAndScore: 'שכבת ספק וציון',
          statusOptions: {
            select: 'בחר',
            active: 'פעיל',
            inactive: 'לא פעיל',
          },
        },
      },
      supplierKpis: {
        header: 'KPIs של ספק',
        fields: {
          onTimePerformance: 'ביצועים בזמן (%)',
          noShowRate: '	שיעור אי-הופעה (%)',
          cancellationsRate: 'שיעור ביטולים (%)',
          acceptanceRate: 'שיעור קבלות (%)',
          avgResponseTime: 'זמן תגובה ממוצע (min)',
          complaints: 'תלונות',
        },
      },
      advancedSettings: {
        header: 'הגדרות מתקדמות',
        fields: {
          areas: 'אזורים',
          attributes: 'מאפיינים',
          excludedAttributes: 'מאפיינים שנשללו',
          minTrips: 'נסיעות מינימליות',
          maxTrips: 'נסיעות מקסימליות',
          allowDecline: 'אפשר לדחות',
          allowSharedRides: 'אפשר נסיעות משותפות',
          weekDays: 'זמינות בימי חול',
        },
      },
      contactInformation: {
        header: 'פרטי קשר',
        fields: {
          name: 'שם',
          type: 'סוג',
          phone: 'טלפון',
          email: 'אימייל',
          address: 'כתובת',
          comment: 'תגובה',
          btnAddContact: 'הוסף איש קשר',
        },
      },
      notes: {
        header: 'הערות',
        fields: {
          notes: 'הערות',
        },
      },
      vehiclesTable: {
        cells: {
          name: 'שם',
          seats: 'מושבים',
          attributes: 'מאפיינים',
        },
      },
    },
    select: 'בחר',
  },
  delete: {
    confirmation: {
      header: 'אישור מחיקת ספק',
      body: 'ספקים נמחקו בהצלחה',
    },
  },
};

export default suppliers;
